import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { record_type, array_type, float64_type, class_type, option_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { DomainEntities_$reflection } from "../DomainEvents.fs.js";
import { ofArray, filter, singleton, choose, empty, map, toArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { bind, map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { ofList, tryFind } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useProjectContext_Static } from "../hooks/UseProjectContext.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { useFeliz_React__React_useFetch_Static_6ADA66EC, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { attributes as attributes_2 } from "../Api/Tags.fs.js";
import { physical, logical } from "../Api/Definition.fs.js";
import { List_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { createObj, compare, structuralHash, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { System_Double__Double_ToLocaleString, EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString } from "../Prelude.fs.js";
import { SearchParams, InfoPanel, Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F } from "../ClientTypes.fs.js";
import { isNullOrWhiteSpace, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi as reactApi_1 } from "../Bindings/Nivo/../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ResponsiveTreeMap } from "@nivo/treemap";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { SelectOption, SelectItem, selectSearch_options_113CE11B, selectSearch_filterOptions_Z7A2530AD } from "../fable_modules/Feliz.SelectSearch.3.1.0/SelectSearch.fs.js";
import { reactApi as reactApi_2 } from "../fable_modules/Feliz.SelectSearch.3.1.0/../Feliz.2.9.0/Interop.fs.js";
import react_select_search from "react-select-search";
import { Interop_defaultProps } from "../fable_modules/Feliz.SelectSearch.3.1.0/./SelectSearch.fs.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import "./Definition.scss";


class DefinitionNode extends Record {
    constructor(name, entityType, entityId, value, children) {
        super();
        this.name = name;
        this.entityType = entityType;
        this.entityId = entityId;
        this.value = value;
        this.children = children;
    }
}

function DefinitionNode_$reflection() {
    return record_type("EPM.App.Definition.DefinitionNode", [], DefinitionNode, () => [["name", string_type], ["entityType", option_type(DomainEntities_$reflection())], ["entityId", option_type(class_type("System.Guid"))], ["value", option_type(float64_type)], ["children", array_type(DefinitionNode_$reflection())]]);
}

function mapDefinition(parentMap, data) {
    const mapped = toArray(map((data_1) => mapDefinition(parentMap, data_1), defaultArg(tryFind(data.EntityId, parentMap), empty())));
    return new DefinitionNode(defaultArg(data.EntityName, "N/A"), data.EntityType, data.EntityId, (data.Total === 0) ? undefined : data.Total, mapped);
}

export function Definition(definitionInputProps) {
    let dependencies_1, elems_2;
    const projectId = definitionInputProps.projectId;
    const context = useFeliz_React__React_useProjectContext_Static();
    const patternInput = reactApi.useState("logical");
    const tab = patternInput[0];
    const setTab = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setAttribute = patternInput_1[1];
    const attributeOpt = patternInput_1[0];
    const attributes = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC((tagParams) => attributes_2(projectId, tagParams), empty(), [projectId]));
    const data = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC(((tab === "logical") ? ((projectId_2) => ((definitionParams_1) => logical(projectId_2, definitionParams_1))) : ((projectId_1) => ((definitionParams) => physical(projectId_1, definitionParams))))(projectId), choose((x_1) => x_1, singleton(map_1((attribute) => ["attribute", attribute], attributeOpt))), [projectId, tab, attributeOpt]));
    let treeMap;
    const properties_2 = ofArray([["labelSkipSize", 16], ["data", (dependencies_1 = [data], reactApi.useMemo(() => {
        if (data != null) {
            const data_1 = data;
            const parentMap = ofList(List_groupBy((r_1) => r_1.ParentEntityId, filter((r) => (r.ParentEntityId != null), data_1), {
                Equals: equals,
                GetHashCode: structuralHash,
            }), {
                Compare: compare,
            });
            return new DefinitionNode(context.Config.Name, undefined, undefined, undefined, toArray(map((data_2) => mapDefinition(parentMap, data_2), filter((r_2) => (r_2.ParentEntityId == null), data_1))));
        }
        else {
            return new DefinitionNode(context.Config.Name, undefined, undefined, undefined, new Array(0));
        }
    }, dependencies_1))], ["value", (node) => node.value], ["identity", "name"], ["valueFormat", ".02s"], ["margin", {
        top: defaultArg(10, 0),
        right: defaultArg(10, 0),
        left: defaultArg(10, 0),
        bottom: defaultArg(10, 0),
    }], ["theme", {
        tooltip: {
            container: {
                background: "#333",
            },
        },
    }], ["labelTextColor", {
        from: "color",
        modifiers: [["darker", 3]],
    }], ["parentLabel", (node_1) => {
        const matchValue = node_1.data;
        if (matchValue != null) {
            const d = matchValue;
            const matchValue_1 = d.entityType;
            if (matchValue_1 != null) {
                return `${d.name} (${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(matchValue_1)})`;
            }
            else {
                return d.name;
            }
        }
        else {
            return "N/A";
        }
    }], ["onClick", (node_2) => {
        const matchValue_2 = node_2.data;
        if (matchValue_2 != null) {
            const data_3 = matchValue_2;
            const matchValue_3 = data_3.entityType;
            const matchValue_4 = data_3.entityId;
            let matchResult, entityId, eventType;
            if (matchValue_3 != null) {
                if (matchValue_4 != null) {
                    matchResult = 0;
                    entityId = matchValue_4;
                    eventType = matchValue_3;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(new SearchParams(4, [new InfoPanel(1, [entityId, eventType])])), false);
                    break;
                }
                case 1: {
                    break;
                }
            }
        }
    }], ["label", (node_3) => {
        const matchValue_6 = node_3.data;
        if (matchValue_6 != null) {
            const matchValue_7 = matchValue_6.value;
            if (matchValue_7 != null) {
                return System_Double__Double_ToLocaleString(matchValue_7);
            }
            else {
                return "N/A";
            }
        }
        else {
            return "N/A";
        }
    }], ["tooltip", (n) => {
        const node_4 = n.node;
        const path = join(" / ", node_4.pathComponents);
        const direct = bind((data_4) => {
            if (equals(node_4.value, data_4.value)) {
                return undefined;
            }
            else {
                return data_4.value;
            }
        }, node_4.data);
        let entityType_4;
        const matchValue_8 = node_4.data;
        if (matchValue_8 != null) {
            const matchValue_9 = matchValue_8.entityType;
            entityType_4 = ((matchValue_9 != null) ? EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(matchValue_9) : undefined);
        }
        else {
            entityType_4 = undefined;
        }
        return createElement("strong", createObj(toList(delay(() => append(singleton_1(["style", {
            color: node_4.color,
        }]), delay(() => {
            let d_4, et_1, d_3, et;
            return (direct != null) ? ((entityType_4 != null) ? ((d_4 = direct, (et_1 = entityType_4, singleton_1(["children", `${path} (${et_1}): ${System_Double__Double_ToLocaleString(node_4.value)} (Direct: ${System_Double__Double_ToLocaleString(d_4)})`])))) : ((d_3 = direct, singleton_1(["children", `${path}: ${System_Double__Double_ToLocaleString(node_4.value)} (Direct: ${System_Double__Double_ToLocaleString(d_3)})`])))) : ((entityType_4 != null) ? ((et = entityType_4, singleton_1(["children", `${path} (${et}): ${System_Double__Double_ToLocaleString(node_4.value)}`]))) : singleton_1(["children", `${path}: ${System_Double__Double_ToLocaleString(node_4.value)}`]));
        }))))));
    }], ["nodeOpacity", 1]]);
    treeMap = reactApi_1.createElement(ResponsiveTreeMap, createObj(properties_2));
    return createElement("div", createObj(ofArray([["className", "definition"], (elems_2 = toList(delay(() => {
        let children_1;
        return append(singleton_1(createElement("div", createObj(Helpers_combineClasses("tabs", ofArray([["className", "is-centered"], ["className", "is-boxed"], ["children", (children_1 = ofArray([createElement("li", createObj(toList(delay(() => append((tab === "logical") ? singleton_1(["className", "is-active"]) : empty_1(), delay(() => {
            let elems;
            return singleton_1((elems = [createElement("a", {
                href: "#",
                onClick: (e) => {
                    e.preventDefault();
                    setTab("logical");
                },
                children: "Logical",
            })], ["children", reactApi.Children.toArray(Array.from(elems))]));
        })))))), createElement("li", createObj(toList(delay(() => append((tab === "physical") ? singleton_1(["className", "is-active"]) : empty_1(), delay(() => {
            let elems_1;
            return singleton_1((elems_1 = [createElement("a", {
                href: "#",
                onClick: (e_1) => {
                    e_1.preventDefault();
                    setTab("physical");
                },
                children: "Physical",
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
        }))))))]), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children_1)),
        }))]]))))), delay(() => {
            let matchValue_11, attributes_1, inputProperties;
            return append((matchValue_11 = attributes, (matchValue_11 != null) ? ((attributes_1 = matchValue_11, singleton_1(createElement("div", {
                className: "px-3",
                children: (inputProperties = createObj(ofArray([["placeholder", "Select Attribute"], ["search", true], selectSearch_filterOptions_Z7A2530AD((item, searchQuery) => (item.value.toLocaleLowerCase().indexOf(searchQuery.trim().toLocaleLowerCase()) >= 0)), ["onChange", (value_62) => {
                    if (isNullOrWhiteSpace(value_62)) {
                        setAttribute(undefined);
                    }
                    else {
                        setAttribute(value_62);
                    }
                }], selectSearch_options_113CE11B(toList(delay(() => append(singleton_1(new SelectOption(0, [new SelectItem("", "-- None Selected --", false)])), delay(() => map((attribute_2) => (new SelectOption(0, [new SelectItem(attribute_2, attribute_2, false)])), attributes_1))))))])), reactApi_2.createElement(react_select_search, Object.assign({}, Interop_defaultProps, inputProperties))),
            })))) : singleton_1(defaultOf())), delay(() => singleton_1(createElement("div", {
                className: "treemap",
                children: treeMap,
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

